import {
  DONATION_ROUTES,
  MODULE_ROUTES,
  ROUTES,
  WEL_MARKET_ROUTES,
} from '@/constants';

type RouteEntry =
  | (typeof ROUTES)[keyof typeof ROUTES]
  | (typeof MODULE_ROUTES)[keyof typeof MODULE_ROUTES]
  | (typeof DONATION_ROUTES)[keyof typeof DONATION_ROUTES]
  | (typeof WEL_MARKET_ROUTES)[keyof typeof WEL_MARKET_ROUTES];

export const findRoute = (pathname: string | null) => {
  if (!pathname) return;

  // 그룹별 HOME 등 키 충돌이 있어 spread 머지로 합치면 ROUTES.HOME(`/`)이 사라진다.
  // 키가 아니라 값으로 평탄화해 모든 라우트를 순회한다.
  const allRoutes: RouteEntry[] = [
    ...Object.values(ROUTES),
    ...Object.values(MODULE_ROUTES),
    ...Object.values(DONATION_ROUTES),
    ...Object.values(WEL_MARKET_ROUTES),
  ];

  let matchedRoute: { route?: RouteEntry; point: number } = { point: 0 };

  for (const route of allRoutes) {
    if (typeof route.pathname === 'string') {
      if (route.pathname === pathname) {
        return route;
      }

      continue;
    }

    const isPathFunction = (
      value: unknown,
    ): value is (
      dynamicPath: Record<string, string | number | null | boolean>,
    ) => string => typeof value === 'function';

    const emptyDynamicParams: Record<string, string | number | null | boolean> =
      {};

    const splitedRoutePathname = isPathFunction(route.pathname)
      ? route.pathname(emptyDynamicParams).split('/')
      : [];
    const splitedCurrentPathname = pathname.split('/');

    if (
      splitedRoutePathname.length === 0 ||
      splitedRoutePathname.length !== splitedCurrentPathname.length
    )
      continue;

    let matchPoint = 0;

    const isAllSame = splitedCurrentPathname.every((path, index) => {
      const partOfRoutePathname = splitedRoutePathname[index];

      //! 동적 경로인 경우 더 일치도가 높은 라우트를 설정

      if (partOfRoutePathname === 'undefined') {
        matchPoint += 1;

        return true;
      }

      if (path === partOfRoutePathname) {
        matchPoint += 2;

        return true;
      }

      return false;
    });

    if (isAllSame && matchedRoute.point < matchPoint) {
      matchedRoute = { route, point: matchPoint };
    }
  }

  return matchedRoute.route;
};
